import { useRef, useCallback, MutableRefObject } from 'react';

export function useFunctionalRef<T>(
  defaultValue: T
): [MutableRefObject<T>, (value: T) => void] {
  const refObject = useRef<T>(defaultValue);
  const setRef = useCallback((value: T) => {
    refObject.current = value;
  }, []);

  return [refObject, setRef];
}
